import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus, faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { formatDate } from "../../../../../../../../utils/common";

const Instrument_Check_Report_Table = ({
  setEdit,
  data,
  currentPage,
  setCurrentPage,
}) => {
  const [editData, setEditData] = useState("");
  const totalPages = Math.ceil(data.total_pages);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const perPage = data?.per_page || data?.data?.length || 0;

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th rowSpan="2">Sr.No</th>
                <th rowSpan="2">Date</th>
                <th rowSpan="2">Instrument ID</th>
                <th rowSpan="2">Instrument Name</th>
                <th rowSpan="2">Maintenance Check Points</th>
                <th colSpan="2" className="text-center">
                  Break Down
                </th>

                <th rowSpan="2">Next Due On</th>
                {/* <th rowSpan="2">Internal / External</th> */}
                <th rowSpan="2">Check By</th>
                <th rowSpan="2"> Remarks</th>
              </tr>

              <tr>
                <th>From</th>
                <th>To</th>
              </tr>
            </thead>

            <tbody>
              {data?.data && data?.data.length > 0 ? (
                data.data.map((row, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * perPage + index + 1}</td>
                    <td>{formatDate(row.createdAt)}</td>
                    <td>{row.Instrument_Management?.unique_id}</td>
                    <td>{row.Instrument_Management?.instrument_name}</td>

                    <td>
                      <ul className="check_point_list">
                        {row.Instrument_Check_Points.map((c, i) => (
                          <li key={i}>
                            {c?.Maintenance_Check_Points_Seeder?.name}
                          </li>
                        ))}
                      </ul>

                      {/* <div className="add_another_holder">
                      <div className="note_text_holder">
                        <p
                          className="red_text"
                          onClick={() => {
                            setEditData(row);
                            setEdit(true);
                          }}
                        >
                          <FontAwesomeIcon icon={faCirclePlus} /> Add Another
                          Document
                        </p>
                      </div>
                    </div> */}
                    </td>

                    <td>{row.from_date}</td>
                    <td>{row.to_date}</td>
                    <td>{row.next_date}</td>
                    {/* <td>{row.type}</td> */}
                    <td>{row.Instrument_Management?.User?.name}</td>
                    <td>{row?.remark}</td>
                    {/* <td>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Type Here Remark..."
                      />
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={10} style={{ textAlign: "center" }}>
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {(data.current_page - 1) * data.per_page + 1} To{" "}
            {Math.min(data.current_page * data.per_page, data.total)} Of{" "}
            {data.total} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Instrument_Check_Report_Table;
